import { Grid } from "@mui/material";
import React from "react";

const Footer = () => {
  return (
    <Grid mt={5} textAlign={"center"} flexGrow={1}>
      <span>&copy; FID Candidature {new Date().getFullYear()} </span>
    </Grid>
  );
};

export default Footer;